/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
import React from 'react';
import GluAllCourses from '../../organisms/glu-all-courses';
import PageSection from '../../organisms/page-section';
import ServiceCardContainer from '../../organisms/service-card-container';
import ScrollToTop from '../ScrollToTop/scrollToTop';
import * as headingStyles from '../../../molecules/main-header/index.module.css';
import { HomeReferralCards } from '../../../molecules/home-referral-image-cards/index.js';
import { createHeadingHighlight } from '../../../../utils/heading-highlight';
import { isCourseNew } from '../../../../utils';

function NewGluHomePage({ data }) {
	const hsCourses = data.healthAndSafetyCourses.nodes.map((course) => ({
		...course,
		isNew: isCourseNew(course.meta?.createdAt),
	}));
	const hrCourses = data.hrCourses.nodes.map((course) => ({
		...course,
		isNew: isCourseNew(course.meta?.createdAt),
	}));
	const { locale } = data;
	const {
		otherServicesTitle,
		otherServices,
		pickedForYou,
		newCourses,
		trendingCourses,
	} = data.datoCmsGluHomepage;
	const titleText = createHeadingHighlight({
		headings:
			data.datoCmsReferABusiness.heroHeader[0].title.value.document
				.children[0].children,
		headingStyles,
	});
	return (
		<div className="overflow-hidden curosal-hide-scroll w-full">
			<GluAllCourses
				coursesData={hrCourses}
				title="HR & Employment Law"
				total="160"
				link="/elearning/hr-and-employment-law/"
				linkText="View All"
				locale={locale}
			/>
			<GluAllCourses
				coursesData={hsCourses}
				title="Health & Safety"
				total="70"
				link="/elearning/health-and-safety/"
				linkText="View All"
				locale={locale}
			/>

			<div className="mb-10">
				{locale !== 'en-CA' &&
					locale !== 'en-IE' &&
					data?.datoCmsReferABusiness?.referralCard?.map((card) => (
						<HomeReferralCards
							locale={locale}
							slug={data?.datoCmsReferABusiness.slug}
							card={card}
							key={card.id}
							titleText={titleText}
							heroHeader={
								data?.datoCmsReferABusiness?.heroHeader[0]
							}
							headingStyles={headingStyles}
						/>
					))}
			</div>
			<GluAllCourses
				coursesData={pickedForYou}
				title="Picked For You"
				link="/elearning/view-all-picked-for-you/"
				linkText="View All"
				locale={locale}
			/>
			<GluAllCourses
				coursesData={newCourses}
				title="New Sessions"
				link="/elearning/view-all-new-courses/"
				linkText="View All"
				locale={locale}
			/>
			<GluAllCourses
				coursesData={trendingCourses}
				title="Current Trending Sessions"
				link="/elearning/view-all-trending-courses/"
				linkText="View All"
				locale={locale}
			/>
			{locale === 'en' && <ScrollToTop />}

			<PageSection theme="Dark" titleBlock={otherServicesTitle.value}>
				<ServiceCardContainer cards={otherServices} />
			</PageSection>
		</div>
	);
}

export default NewGluHomePage;
